let upgradePreparer: (() => Promise<number>) | undefined

export function registerUpgradePreparer(preparer?: () => Promise<number>) {
  upgradePreparer = preparer
}

export async function prepareForSafeUpgrade() {
  if (!upgradePreparer) return 0
  return upgradePreparer()
}
